import { NSARouterMakerResult } from "namirasoft-account-react";
import { ClassifierClassRow } from "namirasoft-inference";
import { Component } from "react";
import { InferenceRouterProps } from "../InferenceRouterProps";
import ClassifierClassesView from "./ClassifierClassesView";

interface ClassifierClassesViewLoaderProps extends NSARouterMakerResult, InferenceRouterProps
{
	classifier_id: string;
}

interface ClassifierClassesViewLoaderState
{
	rows: ClassifierClassRow[] | null;
}

export default class ClassifierClassesViewLoader extends Component<ClassifierClassesViewLoaderProps, ClassifierClassesViewLoaderState>
{
	override state: ClassifierClassesViewLoaderState = { rows: null };

	override componentDidMount(): void { this.load(); }

	override componentDidUpdate(prev: ClassifierClassesViewLoaderProps): void
	{
		if (prev.classifier_id !== this.props.classifier_id)
			this.load();
	}

	private async load(): Promise<void>
	{
		let { classifier_id: id } = this.props;
		if (!id) { this.setState({ rows: null }); return; }
		try
		{
			let row = await this.props.servers.inference.classifier.Get(id);
			this.setState({ rows: row.classes ?? [] });
		}
		catch (e) { console.error(e); }
	}

	override render()
	{
		let { rows } = this.state;
		if (!rows)
			return null;
		return (
			<ClassifierClassesView
				{...this.props}
				classifier_id={this.props.classifier_id}
				rows={rows}
			/>
		);
	}
}